<template>
  <div id="popup-container">
    <v-toolbar dark color="primary">
      <v-toolbar-title class="heading-title">
        Add a new course
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small class="close" @click="closePanel">
        <v-icon dark color="white">fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-row>
        <v-col md="12">
          <v-form>
            <v-text-field
              :error-messages="messages.name"
              v-model="course.name"
              filled
              label="Course Name"
            >
            <!-- <template slot="append-outer">
              <v-tooltip left>
               <template v-slot:activator="{on}">
                <v-icon v-on="on">fa fa-question</v-icon>
               </template>
               <span>Enter course name</span>
              </v-tooltip>
            </template> -->
            </v-text-field>
            <!-- <v-textarea
              v-model="course.description"
              label="Description"
              hint="Enter a description for this course"
              filled
            >
            <template slot="append-outer">
              <v-tooltip left>
               <template v-slot:activator="{on}">
                <v-icon v-on="on">fa fa-question</v-icon>
               </template>
               <span>Enter a description for this course</span>
              </v-tooltip>
            </template>
            </v-textarea> -->
            <v-layout class="mb-5 d-block">
              <ckeditor :editor="editor" class="ckeditor" v-model="course.description" tag-name="textarea" :config="editorConfig"></ckeditor>
            </v-layout>
            <v-layout>
              <v-flex xs12>
                <v-text-field
                  :error-messages="messages.minutes"
                  v-model="course.minutes"
                  label="Duration (mins)"
                  type="number"
                  class="duration"
                  filled
                  :min="0"
                  @keypress="NumbersOnly"
                >
                <template slot="append-outer">
                  <v-tooltip left>
                   <template v-slot:activator="{on}">
                    <v-icon v-on="on">fa fa-question</v-icon>
                   </template>
                   <span>Enter the number of minutes this course would take to complete.</span>
                  </v-tooltip>
                </template>
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout class="mt-5">
              <v-flex xs12>
                <CategorySelect :cat="this.category"/>
              </v-flex>
            </v-layout>
            <v-combobox
              v-model="course.topics"
              :search-input.sync="search"
              multiple
              label="Keywords"
              append-icon
              chips
              deletable-chips
              class="mt-5"
              filled
            >
            <template slot="append-outer">
              <v-tooltip left>
               <template v-slot:activator="{on}">
                <v-icon v-on="on">fa fa-question</v-icon>
               </template>
               <span>Enter keywords that reflect the course and its content, this makes it easier for users to find in the Full Course Library.</span>
              </v-tooltip>
            </template>
            </v-combobox>
            <v-select
              v-model="course.channels"
              :items="channels"
              item-text="name"
              item-value="id"
              label="Playlists"
              multiple
              chips
              deletable-chips
              hint="Assign course to playlists"
              persistent-hint
              filled
              attach
            >
            <template slot="append-outer">
              <v-tooltip left>
               <template v-slot:activator="{on}">
                <v-icon v-on="on">fa fa-question</v-icon>
               </template>
               <span>Assign the course to a single playlist, or to multiple playlists</span>
              </v-tooltip>
            </template>
            </v-select>
            <drop-zone
              :type="type"
              :accepted="accepted"
              class="mt-5 dropzone-container"
              text="Click here to upload Course Image"
              :error-messages="messages.s3_url"
            >
            </drop-zone>
            <label v-if="messages.s3_url"
            :error-messages="messages.s3_url" class="v-messages theme--light error--text">The course image field is required. </label>
            <!-- <template>
              <v-tooltip left>
               <template v-slot:activator="{on}">
                <v-icon v-on="on" class="dropzone-help">fa fa-question</v-icon>
               </template>
               <span>Click here to upload Course Image</span>
              </v-tooltip>
            </template> -->
              <p class="block text-left mt-4 caption">
              Max upload filesize: 10MB <br />
              Accepted file formats: png, jpg
            </p>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
    <v-footer height="68">
      <v-flex px-4 py-4 text-right>
        <v-btn v-if="!s3Uploading || !loading" color="grey300" class="cancel-button" @click="closePanel"
          >Cancel</v-btn
        >
        <v-btn v-if="s3Uploading || loading" color="primary" loading></v-btn>
        <v-btn v-else color="dark-blue" class="ml-4 add-course-button" @click="addCourse"
          >Add New Course</v-btn
        >
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js";
import courseAPI from "@/api/course.js";
import channelAPI from "@/api/channel.js";
import DropZone from "@/components/global/Dropzone";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CategorySelect from './CategorySelect.vue';
export default {
  name: "CreateCourse",
  components: {
    DropZone,
    ClassicEditor,
    CategorySelect
  },
  props: ["params"],
  data() {
    return {
      editorConfig: {
        toolbar: {
          items: [
            'undo', 'redo',
            '|', 'heading',
            '|', 'bold', 'italic',
            '|', 'bulletedList', 'numberedList',
            '|', 'link'
          ]
        },
      },
      editor: ClassicEditor,
      type: "thumbnail",
      accepted: "image/jpg,image/jpeg,image/png",
      course: {},
      channels: [],
      messages: {},
      topics: [],
      search: "",
      imageChanged: false,
      loading: false,
      successMessage: "Course Successfully Added.",
      errorMessage:
        "Oops, something went wrong! Please check information is correct.",
      waitMessage: "Please wait, we are uploading your image.",
      category: null,
    };
  },
  computed: {
    s3Uploading() {
      return this.$store.getters.s3Uploading;
    }
  },
  mounted() {
    this.$store.dispatch("setS3Uploading", false);
    this.getChannels();
    this.setEventBus();
  },
  methods: {
    closePanel() {
      this.$emit("closePanel");
    },
    addCourse() {
      this.loading = true;
      this.course.category_id = this.category ? this.category.id : '';
      courseAPI
        .createCourse(
          this.course,
          this.$store.getters.s3Url,
          this.$store.getters.fileDetails
        )
        .then(() => {
          this.closePanel();
          EventBus.$emit("COURSES_UPDATED", this.params);
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch(err => {
          this.valid = false;
          this.$snotify.error(this.errorMessage);
          this.messages = this.$gf.errorResponse(err);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    getChannels() {
      channelAPI.getChannels("?getall=true").then(response => {
        this.channels = response.data.data;
      });
    },
    NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) || charCode == 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    setEventBus() {
      EventBus.$on("SELCTED_CATEGORY", selectedCategory => {
        this.category = selectedCategory;
      });
      EventBus.$on("FILE_UPLOADED",() => {
        this.$delete(this.messages, "s3_url");
      })
    },
  }
};
</script>
<style scoped>
.ck.ck-sticky-panel .ck-sticky-panel__content_sticky_bottom-limit{
  position: relative;
}
.dropzone-container{
  margin-right: 0 !important;
}
</style>